import defaultMessages from 'ra-language-english';
var defaultI18nProvider = function defaultI18nProvider(locale) {
  return defaultMessages;
};
export default defaultI18nProvider;